module.exports = __webpack_public_path__ + "img/data-server-4.517469c.png";